import React from 'react';
import { Helmet } from 'react-helmet';
var WebsiteSchema = function WebsiteSchema(_ref) {
  var name = _ref.name,
    url = _ref.url,
    description = _ref.description;
  var websiteData = {
    '@context': 'http://schema.org',
    '@type': 'WebSite',
    name: name,
    url: url,
    description: description
  };
  return /*#__PURE__*/React.createElement(Helmet, {
    defer: false
  }, /*#__PURE__*/React.createElement("script", {
    type: "application/ld+json"
  }, JSON.stringify(websiteData)));
};
export default WebsiteSchema;
WebsiteSchema.defaultProps = {
  url: null,
  description: null
};